<div class="notification-wrapper shadow-lg shadow-gray-300" [@slideAndFade]>
  <div class="notification" [ngClass]="'notification--' + notification.type">
    <!-- Icon -->
    <div class="notification__icon" [innerHTML]="iconMap[notification.type || 'info'] | safeHtml"></div>

    <!-- Content -->
    <div class="notification__content">
      @if (notification.title) {
        <p class="notification__title">{{ notification.title }}</p>
      }
      <p class="notification__message" [innerHTML]="notification.message | markdown"></p>
    </div>

    <!-- Close Button -->
    <button class="notification__close" (click)="close()">
      <svg class="notification__close-icon" fill="currentColor" viewBox="0 0 20 20">
        <path
          fill-rule="evenodd"
          d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </button>

    <!-- Timeout Progress Bar -->
    <div class="notification__progress-bar">
      <div class="notification__progress-bar-inner" [style.animation-duration]="notification.duration + 'ms'"></div>
    </div>
  </div>
</div>
